
	import ConnexionForm from '@/components/Authentification/ConnexionForm.vue';
	import LayoutConnexionInscriptionAssure from '@/components/Authentification/LayoutConnexionInscriptionAssure.vue';
	import Vue from 'vue';
	import Component from 'vue-class-component';

	@Component({
		components: {
			LayoutConnexionInscriptionAssure,
			ConnexionForm
		}
	})
	export default class AssureConnexionFC extends Vue {
	}
